/* tslint:disable */
/* eslint-disable */
export enum WorkMeetingParticipantRoleEnum {
  Audience = 'audience',
  Presenter = 'presenter',
  Guest = 'guest'
}
